<template>
  <v-card class="center" max-width="600" flat>
    <h1 class="display-2 align-center my-4">{{ $t('rooms.callEnd.title') }}</h1>
    <v-card-text>
      <div class="btn-block" v-if="authenticated">
        <v-btn class="ma-2" color="primary" @click="backToCall">
          {{ $t('rooms.callEnd.backIn') }}
        </v-btn>
        <v-btn class="ma-2" @click="backToRoom">{{ $t('rooms.callEnd.backList') }}</v-btn>
      </div>
      <div v-else>
        <div class="align-center mb-5">
          <v-expand-transition>
            <div v-if="!voted">
              <p class="headline mb-2">{{ $t('rooms.callEnd.thank') }}</p>
              <p>{{ $t('rooms.callEnd.appreciate') }}</p>
              <Rating v-on:event-send-rating="sendRating" activeComments />
            </div>
          </v-expand-transition>
        </div>
        <div class="btn-block">
          <v-btn class="ma-2" color="primary" @click="backToCall">
            {{ $t('rooms.callEnd.backIn') }}
          </v-btn>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import Rating from '@/components/Rating'

export default {
  name: 'CallEnd',

  components: {
    Rating
  },

  props: {
    authenticated: {
      type: Boolean,
      default: true
    },
    room: Object
  },

  data() {
    return {
      voted: false
    }
  },

  methods: {
    backToCall() {
      this.$mam.liveBackToLive()
      this.$emit('join-room')
    },

    backToRoom() {
      this.$mam.liveBackToRooms()
      this.$emit('back-room')
    },

    async sendRating(ob) {
      const { data, done } = ob
      data.id_live_video = this.room.id_live_video

      const res = await this.$store.dispatch('sendPlayerRating', { from: 'LiveVideo', data })
      if (res) {
        setTimeout(() => {
          this.voted = true
        }, 500)
      }
      done(res)
    }
  }
}
</script>

<style lang="sass" scoped>
.center
  margin: 20px auto 0 auto

.align-center
  text-align: center

.btn-block
  display: flex
  justify-content: center

.btn-block-col
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
</style>
